<template lang="pug">
    multiselect(
        :value="value"
        :options="states"
        label="name"
        track-by="name"
        name="state"
        @input="onInput"
        :disabled="disabled"
    )
        template(slot="option" slot-scope="props")
            span.block {{ props.option.name }}
</template>

<script>
import state from '@js/store/modules/state';
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('state', ['states']),
    },

    beforeCreate() {
        if (!this.$store.hasModule('state')) {
            this.$store.registerModule('state', state);
        }
    },

    mounted() {
        this.getStates();
    },

    methods: {
        ...mapActions('state', ['getStates']),

        onInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/StateSelector.vue